"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import { motion, type MotionProps } from "motion/react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses } from "@huub-web/utils";

import { spacingStyle } from "./Spacing.css";

export type SpacingProps = HTMLAttributes<HTMLHRElement> &
  RecipeVariants<typeof spacingStyle> & { ref?: Ref<HTMLDivElement> };

/**
 * A simple ruler component that can be used to separate content.
 */
export const Spacing: FC<SpacingProps> = ({
  height,
  width,
  grow,
  className,
  ref,
  ...props
}) => (
  <motion.div
    ref={ref}
    className={mergeClasses(spacingStyle({ height, width, grow }), className)}
    aria-hidden="true"
    {...(props as MotionProps)}
  />
);
